import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, HandHeart, BookOpen } from 'lucide-react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { trackCtaClick } from '../lib/ctaTracking';

const STEPS = [
  { id: 'plan-visit', icon: Calendar, title: 'Plan a Visit', text: "Tell us you're coming and we'll save you a seat and meet you at the door.", cta: 'Plan My Visit', to: '/plan-your-visit' },
  { id: 'prayer', icon: HandHeart, title: 'Need Prayer?', text: 'Send a request and a pastor will pray for you this week.', cta: 'Request Prayer', to: '/connect#prayer-request' },
  { id: 'bible-study', icon: BookOpen, title: 'Free Bible Study', text: 'One-on-one or small group, in person or on Zoom. No experience needed.', cta: 'Request a Bible Study', to: '/bible-study' },
];

/** Three next-step cards shown directly below the homepage hero. */
export const HomeNextSteps = () => (
  <section className="py-16 sm:py-20 bg-white" data-testid="home-next-steps">
    <div className="container mx-auto px-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {STEPS.map(({ id, icon: Icon, title, text, cta, to }) => (
          <Card key={id} className="p-6 sm:p-8 border-2 hover:border-church-green hover:shadow-lg transition-all flex flex-col" data-testid={`next-step-${id}`}>
            <div className="w-12 h-12 rounded-full bg-green-50 flex items-center justify-center mb-4">
              <Icon className="w-6 h-6 text-church-green" />
            </div>
            <h2 className="text-xl font-bold text-slate-900 mb-2">{title}</h2>
            <p className="text-slate-600 mb-6 flex-1">{text}</p>
            <Link to={to} onClick={() => trackCtaClick(`card-${id}`)} data-testid={`next-step-${id}-btn`}>
              <Button className="w-full bg-church-green hover:bg-church-green-dark font-semibold">{cta}</Button>
            </Link>
          </Card>
        ))}
      </div>
    </div>
  </section>
);
